import {defineStore} from 'pinia'

export const useAuthenticationStore = defineStore('authentication', {
    state: () => {
        return {
            isAuthenticated: false,
            user: null
        }
    },
    actions: {

        validate(email, password) {

            this.isAuthenticated = password === 'admin';
            return this.isAuthenticated

        },
        markValidated() {
            this.isAuthenticated = true
        },
        logout() {
            this.isAuthenticated = false
        },
        isUserAuthenticated() {
            return this.isAuthenticated
        },
        requiresAuthentication() {

            if ( ! this.isUserAuthenticated()) {
                this.$router.push('/authentication')
            }

        },

        /**
         * This becomes important because for local, now we need to know which user is logged in
         * 
         * @param {Object} user - The user object containing account information
         * @param {string} user.account - The account name of the user
         */
        logUserIn(user) {
            this.user = user
            this.isAuthenticated = true
        },
        logUserOut() {
            this.user = null
            this.isAuthenticated = false
        },
        getUser() {
            return this.user
        }

    },
    getters: {}

})
